import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SnapID from "./SnapID";
import PDTalkingCard from "./PDTalkingCard";
import PDStreakHome from "./PDStreakHome";
import PDOnboardingProfile from "./PDOnboardingProfile";
import FoundHerProfile from "./FoundHerProfile";
import PostFindItLocal from "./PostFindItLocal";
import PDCertificateGenerator from "./modules/streaks/PDCertificateGenerator";
// import FoundHerFeedback from "../orderflow/HerKartFeedback";
// import FoundHerSampleReqest from "../orderflow/HerKartSampleReqest";

import { usePDActiveSubscription } from './hooks/pdActiveSubscription';

export default function FoundHerOneView() {
    const authState = useSelector((state) => state.authReducer);

    const userName = authState?.user?.name || "Founder";
    const userCode = authState?.user?.think5whyscode || "";
    const navigate = useNavigate();

    const {
        subscriptions,
        selectedSubscription,
        loadingSubs,
        product,
        isActive,
        daysLeft,
        formatRange,
        refetch
    } = usePDActiveSubscription();
    
    const modules = [
        { icon: "👩", label: "My Identity", view: "IDENTITY", hasSubModule: true, isComponent: false, name: "profileSubModules" },
        { icon: "🛍️", label: "Post For Local List", view: "POSTFindItLOCAl", hasSubModule: false, isComponent: true, component: PostFindItLocal },
        { icon: "🤝", label: "My Private SHG", action: "hershg", hasSubModule: false, isComponent: false, name: "/foundhershg"  },
        { icon: "📦", label: "Order Management", view: "ORDERS", hasSubModule: true, isComponent: false, name: "psSubModules"  },        
        { icon: "🗂️", label: "Mini ERP", view: "MINIERP", hasSubModule: false, isComponent: false, name: "/minierp"  },        
        { icon: "🔥", label: "Gamified Shopping", view: "STREAKS", hasSubModule: false, isComponent: true, component: PDStreakHome  },
        { icon: "💰", label: "Ask Support Profile", view: "FUNDING", hasSubModule: false, isComponent: false, name: "/foundher-mysupport-profile"  },
        { icon: "🎁", label: "Mentorship", view: "SUPPORT", hasSubModule: false, isComponent: false, name: "/think5whys-counsellors"  },
        { icon: "🌟", label: "MSME Suite", action: "msme", hasSubModule: false, isComponent: false, name: "/msme"  },
        { icon: "🙋", label: "SheEarns", action: "sheearns", hasSubModule: false, isComponent: false, name: "/sheearns"  },  
        { icon: "👯‍♀️", label: "PehchaanSetu", action: "pehchaanSetu", hasSubModule: false, isComponent: false, name: "/pehchaansetu/foundher"  },        
    ];

    const profileSubModules = [
        { icon: "👩", label: "My Profile", action: "PDProfile", isComponent: true, component: FoundHerProfile  },
        { icon: "🆔", label: "SnapId", action: "SNAPID", isComponent: true, component: SnapID },
        { icon: "💜", label: "TalkingCard", view: "TALKINGCARD", isComponent: true, component: PDTalkingCard },
        { icon: "⭐", label: "Trust Badge", view: "TRUSTBADGE", isComponent: true, component: PDCertificateGenerator },      
    ];

    const psSubModules = [
    { icon: "🏪", label: "Stores", action: "MYPROFILE", isComponent: false, name: "/herkart/manage-stores" },
    { icon: "📦", label: "Products", action: "MYPRODUCTS", isComponent: false, name: "/herkart/manage-products" },
    { icon: "🛠️", label: "Services", view: "MYSERVICES", isComponent: false, name: "/herkart/manage-services" },
    { icon: "💬", label: "Feedbacks", view: "MYFEEDBACKS", isComponent: false, name: "/herkart/manage-feedback" },
    { icon: "🧪", label: "Sample Requests", view: "MYSAMPLEREQUESTS", isComponent: false, name: "/herkart/sample-requests"},
    { icon: "🎛️", label: "Dashboard", view: "HERKARTDASHBOARD", isComponent: false, name: "/herkart/dashboard"},
    ];

    const [tabName, setTabName] = useState("IDENTITY");
    const [subTabName, setSubTabName] = useState("");

    const activeModule = modules.find((m) => m.view === tabName || m.action === tabName) || modules[0];

    const activeSubModules = useMemo(() => {
        if (!activeModule?.hasSubModule) return [];

        switch (activeModule.name) {
            case "profileSubModules":
                return profileSubModules;

            case "psSubModules":
                return psSubModules;

            default:
                return [];
        }
    }, [activeModule]);

    const activeSubModule = activeSubModules.find((m) => (m.view || m.action) === subTabName) || activeSubModules[0];
    // if (loadingSubs) return <p>Loading subscription...</p>;

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col">
            <div className="sticky top-0 z-20 bg-gradient-to-r from-pink-600 via-fuchsia-600 to-purple-700 border-b border-purple-900 shadow-lg rounded-b-3xl px-4 py-4">
                <div className="flex items-start justify-between">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="text-3xl">💜</span>
                            <div>
                                <h1 className="text-white text-start text-2xl font-extrabold tracking-tight">
                                    FoundHer OneView
                                </h1>

                                <p className="text-pink-100 text-sm mt-0.5">
                                    One Dashboard • One Entrepreneur • Infinite Possibilities
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="hidden lg:flex items-center justify-center w-14 h-14 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 text-3xl">
                        🚀
                    </div>
                </div>
                <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1.5">
                    <span className="text-sm">👋</span>
                    <span className="text-xs text-white font-semibold">
                        {userName}
                    </span>
                    <span className="text-pink-200 text-xs">
                        • {userCode}
                    </span>
                    {/* <span className="text-gray-200 ml-2 text-xs lg:-text-sm">{isActive ? `Active Subscription (Days Left: ${daysLeft})` : "Expired/Inactive Subscription"}</span> */}
                    <span className="text-gray-200 ml-2 text-xs lg:-text-sm">
                        {loadingSubs
                            ? "Loading subscription..."
                            : isActive
                            ? `Active Subscription (Days Left: ${daysLeft})`
                            : "Expired/Inactive Subscription"}
                    </span>
                </div>
            </div>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 place-items-center bg-[#0f172a] border-l border-y border-purple-900 mt-2 gap-0.5 mb-2">
                {modules.map((module) => (
                    <button
                        key={module.view}
                        onClick={() => {
                            if (!module.isComponent && !module.hasSubModule && module.name.startsWith("/")) {
                                navigate(module.name);
                                return;
                            }

                            setTabName(module.view || module.action);
                            setSubTabName("");
                        }}
                        className={`flex justify-start text-left flex-row px-2 py-1 text-xs lg:text-sm font-bold border-r border-b border-purple-900 transition-all duration-200
                            ${
                                tabName === module.view
                                    ? "bg-pink-600 text-white"
                                    : "bg-purple-700 hover:bg-purple-600 text-white"
                            }`}
                    >
                        {module.icon} {module.label}
                    </button>
                ))}
            </div>
            {activeModule?.hasSubModule && activeSubModules.length > 0 && (
                <div className="grid grid-cols-2 lg:grid-cols-6 place-items-center bg-[#111827] border-l border-r border-b border-purple-900 gap-0.5">
                    {activeSubModules.map((sub) => (
                        <button
                            key={sub.view || sub.action}
                            onClick={() => {
                                if (!sub.isComponent && sub.name?.startsWith("/")) {
                                    navigate(sub.name);
                                    return;
                                }

                                setSubTabName(sub.view || sub.action);
                            }}
                            className={`px-1 py-1 justify-left text-left text-xs lg:text-sm font-semibold border-r border-purple-900 transition-all ${
                                (sub.view || sub.action) === subTabName
                                    ? "bg-cyan-600 text-white"
                                    : "bg-zinc-800 hover:bg-zinc-700 text-gray-200"
                            }`}
                        >
                            {sub.icon} {sub.label}
                        </button>
                    ))}
                </div>
            )}            
            <div className="flex-1 p-5">
                {activeModule.isComponent && activeModule.component && (() => {
                    const Component = activeModule.component;

                    return (
                        <Component
                            moduleCalled="foundher"
                            userId={authState?.user?._id}
                            userCode={userCode}
                            userName={userName}
                        />
                    );
                })()}
                {activeModule.hasSubModule && activeSubModule?.isComponent && activeSubModule.component && (() => {
                    const Component = activeSubModule.component;

                    return (
                        <Component
                            moduleCalled="foundher"
                            userId={authState?.user?._id}
                            userCode={userCode}
                            userName={userName}
                        />
                    );
                })()}

                {!activeModule.isComponent &&
                    !activeModule.hasSubModule && (
                    <div className="max-w-2xl mx-auto w-full bg-[#111827] border border-purple-900 rounded-3xl p-8 text-center shadow-xl">

                        <div className="text-6xl mb-5">
                            {activeModule.icon}
                        </div>

                        <h2 className="text-3xl font-bold text-pink-300">
                            {activeModule.label}
                        </h2>

                        <p className="mt-6 text-gray-300 text-lg leading-relaxed">
                            This space is being thoughtfully crafted to help women entrepreneurs grow, connect, and thrive.
                        </p>

                        <p className="mt-4 text-cyan-300 text-xl font-semibold">
                            ✨ Coming Soon — We're putting the finishing touches on something special for you. ✨
                        </p>

                        <div className="mt-8 inline-flex items-center gap-2 bg-pink-500/20 border border-pink-500/40 rounded-full px-5 py-2 text-pink-200 text-sm">
                            💜 Every great journey is built one step at a time.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}